<template>
  <div id="client-screen">
    <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="#314e5d"></v-progress-linear>

    <v-dialog v-model="dialog_welcome" :persistent="carousel_welcome !== 5">
      <div class="welcome-message">
        <div class="wl-h-title">Bem vindo(a)</div>
        <div class="wl-h-subtitle">Antes de começar, confira abaixo alguns benefícios do aplicativo <b>CheckMotors</b>:</div>
        <v-carousel v-model="carousel_welcome" :show-arrows="carousel_welcome !== 5" hide-delimiters :continuous="false">
          <v-carousel-item>
            <div>
              <div class="wl-header">
                <img :src="require('@/assets/icons/8.svg')" height="230" />
              </div>
              <div class="wl-list">
                <v-alert dense text prominent border="left" color="primary" icon="mdi-checkbox-marked-circle-outline">
                  Receba ordens de serviço com fotos e videos dos serviços realizados.
                </v-alert>
              </div>
            </div>
          </v-carousel-item>

          <v-carousel-item>
            <div class="welcome-message">
              <div class="wl-header">
                <img :src="require('@/assets/icons/3.svg')" height="230" />
              </div>
              <div class="wl-list">
                <v-alert dense text prominent border="left" color="primary" icon="mdi-checkbox-marked-circle-outline">
                  Acesse o histórico de todos serviços realizados em seu veículo.
                </v-alert>
              </div>
            </div>
          </v-carousel-item>

          <v-carousel-item>
            <div class="welcome-message">
              <div class="wl-header">
                <img :src="require('@/assets/icons/10.svg')" height="230" />
              </div>
              <div class="wl-list">
                <v-alert dense text prominent border="left" color="primary" icon="mdi-checkbox-marked-circle-outline">
                  Agende serviços sem precisar ligar para o estabelecimento.
                </v-alert>
              </div>
            </div>
          </v-carousel-item>

          <v-carousel-item>
            <div class="welcome-message">
              <div class="wl-header">
                <img :src="require('@/assets/icons/7.svg')" height="230" />
              </div>
              <div class="wl-list">
                <v-alert dense text prominent border="left" color="primary" icon="mdi-checkbox-marked-circle-outline">
                  Solicite o serviço leva-e-traz direto na sua localização atual.
                </v-alert>
              </div>
            </div>
          </v-carousel-item>

          <v-carousel-item>
            <div class="welcome-message">
              <div class="wl-header">
                <img :src="require('@/assets/icons/11.svg')" height="230" />
              </div>
              <div class="wl-list">
                <v-alert dense text prominent border="left" color="primary" icon="mdi-checkbox-marked-circle-outline">
                  Os melhores prestadores de serviço automotivos e classificados da região.
                </v-alert>
              </div>
            </div>
          </v-carousel-item>

          <v-carousel-item>
            <div class="welcome-message">
              <div class="final-step">
                <v-icon size="80" color="primary">mdi-checkbox-marked-circle-outline</v-icon>
                <h3 class="mt-1">Desenvolvido por quem cuida de carros para quem cuida do carro!</h3>
                <v-alert dense text prominent border="left" color="primary" style="font-size: 12px !important" class="mt-4">
                  Escolha sempre empresas com o selo <b>CheckMotors</b> se quiser todos esses benefícios gratuitamente.
                </v-alert>
                <v-btn @click="dialog_welcome = false" class="ma-2" outlined color="primary"> ENTENDIDO, PODE FECHAR! </v-btn>
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-dialog>

    <v-tabs-items v-model="mainTabs" touchless>
      <!-- <v-tab-item>
        <div class="cs-map">
          <GmapMap
            ref="gmap"
            :options="gmap.options"
            :center="center"
            :zoom="15"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
          >
            <GmapMarker
              v-if="current_postion"
              :position="current_postion"
              :icon="{ url: require('@/assets/maps/current_marker.png')}"
            />
            <GmapMarker
              :key="index"
              v-for="(m, index) in filteredMarkers()"
              :position="m.position"
              :clickable="true"
              :icon="{ url: require('@/assets/maps/'+m.marker)}"
              @click="toggleInfoWindow(m)"
            />
          </GmapMap>
        </div>
      </v-tab-item> -->

      <!-- <v-tab-item>
        <div class="cs-list">
          <div class="list-banner">
            <v-img :src="require('@/assets/example_banner.png')"/>
          </div>
          <div class="list-city">
            {{ getCity() }}
          </div>
          <v-alert
            dense
            text
            border="left"
            color="primary"
            style="margin-top: 20px;font-size: 12px;padding-right: 12px;text-align: center;"
          >
            Escolha sempre empresas com o selo <b>CheckMotors</b> se quiser receber R.S. com imagens e videos do serviço realizado.
          </v-alert>
          <div class="list-workshops">
            <div class="separator">
              <v-divider></v-divider>
              <div class="label">Abertos agora</div>
            </div>
            <div @click="toggleInfoWindow(marker)" v-for="marker in filteredMarkers('open')" :key="marker.organization.ref" class="workshop">
              <div class="details">
                <div class="ws-title">
                  Mocelin Auto Center
                </div>
                <div class="subtitle">
                  CENTRO AUTOMOTIVO
                </div>
                <div class="detail-tags">
                  <div class="tag evaluation">
                    <v-icon color="#fb8c00" size="13">mdi-map-marker</v-icon> {{ calculateDistance(current_postion, marker.position) }} km
                  </div>
                  <div class="tag checkmotors">
                    <v-icon color="#47b38b" size="13">mdi-shield-check</v-icon> CheckMotors
                  </div>
                </div>
              </div>
              <div class="logo">
                <img src="https://app-confia-midias.s3.us-east-1.amazonaws.com/1/media/logo_mocelin.png">
              </div>
              <div class="tags">
                <div class="tag">
                  <v-icon size="13">mdi-car-hatchback</v-icon> Leva e traz
                </div>
                <div class="tag">
                  <v-icon size="13">mdi-calendar-clock</v-icon> Agendamento
                </div>
                <div class="tag">
                  <v-icon size="13">mdi-text-box-outline</v-icon> Orçamento
                </div>
                <div class="tag">
                  <v-icon size="13">mdi-label</v-icon> BOSCH
                </div>
              </div>
            </div>
            <div v-if="filteredMarkers('open').length === 0" class="no-results">
              <v-img contain style="height: 110px; filter: grayscale(1); margin-bottom: 13px;" :src="require('@/assets/vehicle-workshop.png')"/>
              <h3>Sem estabelecimentos abertos</h3>
              <small>Altere algum dos filtros para buscar novamente ou <br/> tente novamente mais tarde.</small>
            </div>
            <div v-if="filteredMarkers('closed').length !== 0">
              <div class="separator">
                <v-divider></v-divider>
                <div class="label">Fechados</div>
              </div>
              <div @click="toggleInfoWindow(marker)" v-for="marker in filteredMarkers('closed')" :key="marker.organization.ref" class="workshop closed">
                <div class="details">
                  <div class="ws-title">
                    {{ marker.organization.name }}
                  </div>
                  <div class="subtitle">
                    {{ getMarkerType(marker.type) }}
                  </div>
                  <div class="detail-tags">
                    <div v-if="current_postion && dialog_organization.position" class="tag evaluation">
                      <v-icon color="#fb8c00" size="13">mdi-map-marker</v-icon> {{ calculateDistance(current_postion, dialog_organization.position) }} km
                    </div>
                    <div v-if="marker.organization.only_map_point === 0" class="tag checkmotors">
                      <v-icon color="#47b38b" size="13">mdi-shield-check</v-icon> CheckMotors
                    </div>
                  </div>
                </div>
                <div class="logo">
                  <img :src="getMarkerParameter(marker.parameters, 'REPORT_LOGO')">
                </div>
                <div class="tags">
                  <div class="tag">
                    <v-icon size="13">mdi-car-hatchback</v-icon> Leva e traz
                  </div>
                  <div class="tag">
                    <v-icon size="13">mdi-calendar-clock</v-icon> Agendamento
                  </div>
                  <div class="tag">
                    <v-icon size="13">mdi-text-box-outline</v-icon> Orçamento
                  </div>
                  <div class="tag">
                    <v-icon size="13">mdi-label</v-icon> BOSCH
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-tab-item> -->

      <!-- <v-tab-item>
        asd
      </v-tab-item> -->

      <v-tab-item>
        <GarageTab @logout="logout()" />
      </v-tab-item>
    </v-tabs-items>

    <!-- <div v-if="mainTabs < 2" class="cs-header">
      <div class="filter">
        <v-icon>mdi-tune</v-icon>
      </div>
      <div class="search-bar">
        <v-text-field
          v-model="markers_filter.term"
          label="Pesquisar no CheckMotors"
          hide-details
          clearable
          flat
          solo
        ></v-text-field>
      </div>
      <div class="user-avatar">
        <v-avatar
          class="float-right"
          color="primary"
          size="32"
        >
          <v-img :src="require('@/assets/profile_default.png')"/>
        </v-avatar>
      </div>
    </div>

    <div v-if="mainTabs < 2" class="cs-shortcut">
      <v-chip-group
        mandatory
        active-class="primary"
      >
        <v-chip
          @click="markers_filter.type = tag.id"
          v-for="tag in tags"
          :key="tag.id"
          color="white"
        >
          {{ tag.description }}
        </v-chip>
      </v-chip-group>
    </div> -->

    <div class="user-not-logged">
      <v-btn v-if="!user" @click="redirectLogin()" color="primary" depressed large>
        <v-icon class="mr-3">mdi-account-circle</v-icon> ACESSAR MEU CADASTRO
      </v-btn>
    </div>

    <v-bottom-sheet v-model="dialog_organization.status">
      <div v-if="dialog_organization.status" class="dialog-organization">
        <div class="content">
          <div class="c-header" :style="'background-image: url(' + getDialogOrganizationParameter('COVER_PHOTO') + ')'">
            <div class="dialog-actions">
              <div class="action" style="padding: 2px">
                <v-icon color="#fff" size="25">mdi-exclamation</v-icon>
              </div>
              <div @click="dialog_organization.status = false" class="action right">
                <v-icon color="#fff" size="30">mdi-close</v-icon>
              </div>
              <div class="action right" style="padding: 2px; margin-right: 3px">
                <v-icon color="#fff" size="26">mdi-share-variant-outline</v-icon>
              </div>
            </div>
            <div class="organization-logo">
              <v-img height="59px" :src="getDialogOrganizationParameter('REPORT_LOGO')"></v-img>
            </div>
            <div class="organization-labels">
              <v-chip label class="ma-0 mr-3" color="#fb8c00" dark>
                <v-icon size="15" class="mr-1">mdi-map-marker</v-icon> {{ calculateDistance(current_postion, dialog_organization.position) }} km
              </v-chip>
              <v-chip
                @click="calculateDistance()"
                v-if="dialog_organization.organization.only_map_point === 0"
                label
                class="ma-0"
                color="#47b38b"
                dark
              >
                <v-icon size="13" class="mr-1">mdi-shield-check</v-icon> CheckMotors
              </v-chip>
            </div>
          </div>
          <div class="c-details">
            <div class="cd-title">
              {{ dialog_organization.organization.name }}
            </div>
            <div class="cd-subtitle">
              {{ getMarkerType(dialog_organization.type) }}
            </div>
            <div class="c-details-actions">
              <div @click="openURL(getDialogOrganizationLink('whatsapp'))" class="action">
                <div class="a-icon"><v-icon size="40" color="#3e515f">mdi-whatsapp</v-icon></div>
                <div class="a-title">Whatsapp</div>
                <div class="a-subtitle">Principal</div>
              </div>
              <div @click="openURL(getDialogOrganizationLink('location'))" class="action">
                <div class="a-icon"><v-icon size="40" color="#3e515f">mdi-map-marker</v-icon></div>
                <div class="a-title">Localização</div>
                <div class="a-subtitle">Abrir GPS</div>
              </div>
              <div @click="openURL(getDialogOrganizationLink('schedule'))" class="action">
                <div class="a-icon"><v-icon size="40" color="#3e515f">mdi-calendar-month</v-icon></div>
                <div class="a-title">Agendamento</div>
                <div class="a-subtitle">Online</div>
              </div>
            </div>
            <div class="c-details-item" style="margin-top: 0px">
              <div class="cdi-title">Horário de funcionamento</div>
              <table style="width: 100%">
                <tbody>
                  <tr>
                    <td
                      v-if="dialog_organization.work_schedule_status === 'open'"
                      style="
                        text-align: center;
                        width: 22%;
                        color: #28a745;
                        border: 1px solid #28a745;
                        border-radius: 5px;
                        font-size: 11px;
                        padding: 3px 0px;
                      "
                    >
                      <v-icon color="#28a745" size="25" style="margin-bottom: 2px">mdi-alarm-check</v-icon> <br />
                      ABERTO
                    </td>
                    <td
                      v-else
                      style="
                        text-align: center;
                        width: 22%;
                        color: rgb(255, 159, 26);
                        border: 1px solid rgb(255, 159, 26);
                        border-radius: 5px;
                        font-size: 11px;
                        padding: 3px 0px;
                      "
                    >
                      <v-icon color="rgb(255, 159, 26)" size="25" style="margin-bottom: 2px">mdi-alarm</v-icon> <br />
                      FECHADO
                    </td>
                    <td style="padding-left: 10px; border: 1px solid #e8e9e9; border-radius: 5px">
                      Segunda a Sexta:<br />
                      <b
                        >{{ dialog_organization.work_schedule.week_morning_start.slice(0, -3) }} -
                        {{ dialog_organization.work_schedule.week_morning_end.slice(0, -3) }} |
                        {{ dialog_organization.work_schedule.week_afternoon_start.slice(0, -3) }} -
                        {{ dialog_organization.work_schedule.week_afternoon_end.slice(0, -3) }}</b
                      >
                    </td>
                    <td style="padding-left: 10px; border: 1px solid #e8e9e9; border-radius: 5px">
                      Sábado:<br />
                      <b
                        >{{ dialog_organization.work_schedule.weekend_morning_start.slice(0, -3) }} -
                        {{ dialog_organization.work_schedule.weekend_morning_end.slice(0, -3) }}</b
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="c-details-item">
              <div class="cdi-title">Formas de pagamento</div>
              <table class="wc-table-payment">
                <tbody>
                  <tr>
                    <td v-if="dialog_organization.payment_methods.money === 1">
                      <v-icon color="#3e515f">mdi-cash-multiple</v-icon> <br />
                      <span>Dinheiro</span>
                    </td>
                    <td v-if="dialog_organization.payment_methods.debit === 1">
                      <v-icon color="#3e515f">mdi-credit-card-outline</v-icon> <br />
                      <span>Débito</span>
                    </td>
                    <td v-if="dialog_organization.payment_methods.credit === 1">
                      <v-icon color="#3e515f">mdi-credit-card</v-icon> <br />
                      <span>Crédito</span>
                    </td>
                    <td v-if="dialog_organization.payment_methods.ticket === 1">
                      <v-icon color="#3e515f">mdi-file-document-outline</v-icon> <br />
                      <span>Boleto</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="c-details-item">
              <div class="cdi-title">Serviços</div>
              <div class="wc-list">
                <ul data-columns="3" style="columns: auto 3">
                  <li v-for="service in dialog_organization.services" :key="service.order">
                    <span>{{ service.description }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="c-ads-banner">
              <v-img :src="require('@/assets/example_banner.png')" />
            </div>
          </div>
        </div>
      </div>
    </v-bottom-sheet>

    <v-bottom-navigation
      v-model="mainTabs"
      fixed
      grow
      color="#48B38B"
      :style="isIphone() ? 'z-index: 100; padding-bottom: 10px; height: 70px;' : 'z-index: 100'"
    >
      <!-- <v-btn style="width: auto!important;">
        <span>Mapa</span>
        <v-icon>mdi-map-marker-radius</v-icon>
      </v-btn>

      <v-btn style="width: 90px!important;">
        <span>Lista</span>
        <v-icon>mdi-format-list-bulleted</v-icon>
      </v-btn>

      <v-btn style="width: auto!important;">
        <span>Classificados</span>
        <v-icon>mdi-car-search</v-icon>
      </v-btn> -->

      <v-btn style="width: auto !important">
        <span>Garagem</span>
        <v-icon>mdi-car-multiple</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<!-- eslint-disable no-undef -->
<script>
import GarageTab from '@/components/Client/GarageTab';

export default {
  name: 'Client',
  components: { GarageTab },
  data: () => ({
    user: null,
    user_vehicles: null,
    location: null,
    loading: false,
    current_postion: null,
    center: {
      lat: -13.8294557,
      lng: -56.0825088
    },
    mainTabs: 0,
    gmap: {
      options: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          }
        ]
      }
    },
    markers: [],
    markers_filter: {
      type: '*',
      term: null
    },
    tags: [],
    dialog_organization: {
      status: false
    },
    dialog_welcome: false,
    carousel_welcome: 0
  }),
  mounted() {
    this.user = this.$store.getters['Auth/user'];
    this.requestMarkersTypes();
  },
  methods: {
    redirectLogin() {
      // window.location.href = '/login';
    },
    getVehicles() {
      const self = this;
      self.$http.get('/user/garage').then((response) => {
        self.user_vehicles = response.data;
      });
    },
    requestMarkersTypes() {
      const self = this;
      self.$http.get('/public/organizations/types').then((response) => {
        self.tags = [{ id: '*', description: 'Todos' }, ...response.data];
        self.getCurrentCoordinates();
      });
    },
    requestMarkers() {
      const self = this;
      self.$http
        .get('/public/organizations', {
          params: {
            country: self.location[3].short_name,
            state: self.location[2].short_name,
            city: self.location[1].short_name.toUpperCase()
          }
        })
        .then((response) => {
          self.markers = response.data;
          self.fitbounds();
        });
    },
    filteredMarkers(scheduleStatus) {
      let filters = {};

      if (scheduleStatus === 'open') {
        filters = { work_schedule_status: 'open' };
      } else if (scheduleStatus === 'closed') {
        filters = { work_schedule_status: 'closed' };
      }

      if (this.markers_filter.type !== '*') {
        filters = { ...filters, type: this.markers_filter.type };
      }

      const results = this.markers.filter((obj) => Object.keys(filters).every((c) => obj[c] === filters[c]));

      if (this.markers_filter.term) {
        return results.filter((obj) => obj.organization.name.toUpperCase().includes(this.markers_filter.term.toUpperCase()));
      }

      return results;
    },
    toggleInfoWindow(marker) {
      this.dialog_organization = { status: true, ...marker };
    },
    requestLocation(lat, lng) {
      this.$gmapApiPromiseLazy().then(() => {
        // eslint-disable-next-line no-undef
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK') {
            const location = results.filter((res) => res.types.includes('postal_code'));
            this.location = location[0].address_components;
            this.loading = false;
          }
        });
      });
    },
    calculateDistance(position, destiny) {
      return (
        google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(position.lat, position.lng),
          new google.maps.LatLng(destiny.lat, destiny.lng)
        ) / 1000
      ).toFixed(2);
    },
    fitbounds() {
      this.$refs.gmap.$mapPromise.then((map) => {
        // eslint-disable-next-line no-undef
        const bounds = new google.maps.LatLngBounds();
        // eslint-disable-next-line no-restricted-syntax
        for (const m of this.markers) {
          bounds.extend(m.position);
        }
        map.fitBounds(bounds);
      });
    },
    getCurrentCoordinates() {
      this.loading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      }
    },
    showPosition(position) {
      this.current_postion = { lat: position.coords.latitude, lng: position.coords.longitude };
      this.requestLocation(position.coords.latitude, position.coords.longitude);
    },
    getWelcomeMessage() {
      const hours = new Date().getHours();

      if (hours >= 18 && hours < 24) {
        return 'Boa noite';
      }

      if (hours >= 12 && hours < 18) {
        return 'Boa tarde';
      }

      if (hours >= 0 && hours < 12) {
        return 'Bom dia';
      }

      return '--';
    },
    getDialogOrganizationParameter(code) {
      const find = this.dialog_organization.parameters.find((parameter) => parameter.code === code);
      return find.value;
    },
    getMarkerParameter(parameters, code) {
      const find = parameters.find((parameter) => parameter.code === code);
      return find.value;
    },
    getDialogOrganizationLink(code) {
      const find = this.dialog_organization.links.find((parameter) => parameter.code === code);
      return find.value;
    },
    getCity() {
      return this.location ? `${this.location[1].short_name} - ${this.location[2].short_name}` : '--';
    },
    getMarkerType(tagId) {
      const find = this.tags.find((tag) => tag.id === tagId);
      return find.description;
    },
    logout() {
      this.$store.dispatch('Auth/logout');
      this.$router.push('/login');
    },
    isIphone() {
      if (this.getOS() === 'iOS') {
        return true;
      }
      return !!(this.$route.query.t && this.$route.query.t === 'ios');
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    openURL(url) {
      window.open(url);
    }
  },
  watch: {
    location: {
      handler(location) {
        if (location[1].short_name) {
          this.requestMarkers();
        }
      }
    },
    mainTabs: {
      handler(tab) {
        if (tab === 3) {
          this.getVehicles();
        }
      }
    }
  }
};
</script>

<style lang="scss">
#client-screen {
  height: 100%;

  .hidden-effect {
    transform: translate3d(0, -120px, 0);
    transition: 0.3s ease all;
  }

  .cs-header {
    position: fixed;
    z-index: 99;
    margin: 19px;
    width: calc(100% - 38px);
    background-color: #fff;
    border-radius: 13px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);

    .search-bar {
      width: 67%;
      float: left;
    }

    .filter {
      width: 15%;
      float: left;
      border-right: 1px solid #dfdfdf;
      padding: 0px 18px;
      margin: 11px 0px;

      .v-atavar {
        border: 2px solid #337d61;
      }
    }

    .user-avatar {
      width: 18%;
      float: left;
      border-left: 1px solid #dfdfdf;
      padding: 0px 18px;
      margin: 8px 0px;

      .v-atavar {
        border: 2px solid #337d61;
      }
    }
  }

  .cs-shortcut {
    position: fixed;
    top: 53px;
    z-index: 99;
    margin: 19px 21px 19px;
    width: 100%;
    overflow: hidden;

    .v-chip {
      box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
    }
  }

  .cs-map {
    height: inherit;
  }

  .cs-list {
    height: inherit;
    margin: 130px 20px;
    padding-top: 20px;
    border-top: 1px solid #dfdfdf;

    .list-banner {
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
    }

    .list-city {
      width: 100%;
      border-radius: 10px;
      background-color: #f1f1f1;
      color: #3e515f;
      text-align: center;
      margin-top: 20px;
      font-size: 18px;
      font-weight: bold;
      padding: 8px 0;
      text-transform: uppercase;
    }

    .list-workshops {
      margin-top: 20px;

      .workshop {
        width: 100%;
        padding: 10px 15px;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
        overflow: hidden;
        margin-bottom: 23px;

        &.closed {
          opacity: 0.6;
        }

        .details {
          float: left;
          width: 75%;

          .ws-title {
            color: #3e515f;
            font-weight: bold;
            text-transform: uppercase;
          }

          .subtitle {
            font-size: 11px;
            text-transform: uppercase;
          }

          .detail-tags {
            float: left;
            overflow: hidden;
            margin-top: 3px;

            .tag {
              float: left;
              font-size: 11px;
              border-radius: 5px;
              margin-right: 6px;

              &.evaluation {
                color: #fb8c00;
              }

              &.checkmotors {
                color: #47b38b;
              }
            }
          }
        }

        .logo {
          float: left;
          width: 25%;
          display: flex; /* establish flex container */
          flex-direction: column; /* make main axis vertical */
          justify-content: center; /* center items vertically, in this case */
          align-items: center;
          border: 1px solid #eee;
          border-radius: 5px;
          height: 60px;
          padding: 7px;

          img {
            width: 100%;
          }
        }

        .tags {
          overflow: hidden;
          float: left;
          border-top: 1px solid #eee;
          width: 100%;
          margin-top: 10px;
          padding-top: 8px;

          .tag {
            float: left;
            border: 1px solid #eee;
            padding: 3px 6px;
            font-size: 11px;
            border-radius: 5px;
            margin-right: 3px;
          }
        }
      }
    }
  }

  .cs-garage {
    height: inherit;

    .background-top {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      height: 115px;
      background-color: #f1f1f1;
      content: ' ';
    }

    .cs-garage-statics {
      background-color: #fff;
      z-index: 10;
      top: 0px;
      position: fixed;
      width: -webkit-fill-available;
      margin: 83px 20px 10px 20px;
      border-radius: 10px;
      padding: 10px 15px;
      border: 2px solid #eee;
      text-transform: uppercase;

      .statistic {
        color: #3e515f;
        float: left;
        width: 33%;
        text-align: center;

        &:nth-child(2) {
          border-left: 1px solid #eee;
          border-right: 1px solid #eee;
        }

        .value {
          font-weight: bold;
          font-size: 17px;
        }

        .description {
          font-size: 10px;
        }
      }
    }

    .cs-garage-header {
      overflow: hidden;
      z-index: 10;
      top: 0px;
      position: fixed;
      width: -webkit-fill-available;
      margin: 20px;

      .user-avatar {
        width: 13%;
        overflow: hidden;
        float: left;
      }

      .user-details {
        width: 60%;
        float: left;
        padding-left: 15px;
        padding-top: 4px;
        color: #3e515f;
        line-height: 20px;

        .name {
          font-size: 17px;
          font-weight: bold;
        }

        .phone {
          font-size: 13px;
        }
      }

      .user-actions {
        float: left;
        width: 27%;
        padding-top: 8px;

        .v-icon {
          font-size: 28px;
          float: right;
          margin-left: 13px;

          &:first-child {
            border-left: 1px solid #cecece;
            padding-left: 13px;
          }
        }
      }
    }

    .cs-garage-content {
      margin: 165px 20px 80px 20px;
      width: -webkit-fill-available;
      height: inherit;

      .no-vehicles {
        margin-top: 20%;
        text-align: center;
      }

      .vehicle {
        width: 100%;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
        overflow: hidden;
        margin-bottom: 23px;
        margin-top: 4px;

        .vehicle-details {
          table {
            width: 100%;
            border-radius: 5px;
            text-transform: uppercase;
            padding: 3px 5px;

            tr {
              text-align: center;

              td {
                border: 1px solid #d9d9d9;
                padding-top: 6px;
                border-radius: 4px;
                color: #3e515f;

                img {
                  height: 30px;
                }

                .value {
                  font-weight: bold;
                  font-size: 15px;
                  line-height: 15px;
                }

                .description {
                  font-size: 10px;
                }
              }
            }
          }
        }
      }
    }
  }

  .user-not-logged {
    position: fixed;
    bottom: 70px;
    width: 100%;
    text-align: center;
  }

  .v-bottom-navigation .v-btn .v-btn__content span {
    margin-top: 4px !important;
  }

  .v-bottom-navigation {
    border-top-right-radius: 35px;
    border-top-left-radius: 35px;
    overflow: hidden;

    .v-btn {
      height: auto !important;
      background-color: transparent !important;

      &:nth-child(2) {
        border-left: 1px solid #eee;
        // border-right: 1px solid #eee;
      }

      &:nth-child(3) {
        width: 500px;
        border-left: 1px solid #eee;
        border-right: 1px solid #eee;
      }

      &:nth-child(4) {
        width: 500px;
      }
    }
  }

  .v-window {
    height: inherit;

    .v-window-item {
      height: inherit;
    }
  }

  .separator {
    overflow: hidden;
    padding: 10px 5px;

    .label {
      margin-top: -14px;
      background-color: #fff;
      float: left;
      padding-right: 12px;
      font-weight: bold;
      font-size: 17px;
    }
  }

  .no-results {
    margin: 20% 0;
    text-align: center;
  }
}

.dialog-organization {
  background-color: #f3f3f3;

  .content {
    .c-header {
      background-image: linear-gradient(#dbd8d8, #ffffff);
      padding: 15px 10px 10px 10px;
      border-top: 3px solid #3e515f;
      background-size: cover;
      height: 216px;
      position: relative;

      .dialog-actions {
        background-color: rgba(62, 81, 95, 0.36);
        color: #fff;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        height: 40px;

        .action {
          border: 1px solid #fff;
          margin: 4px 8px;
          border-radius: 6px;
          float: left;

          &.right {
            float: right;
          }
        }
      }

      .organization-logo {
        padding: 5px 10px;
        position: absolute;
        bottom: -35px;
        border-radius: 5px;
        background-color: #fff;
        width: 150px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
      }

      .organization-labels {
        position: absolute;
        bottom: -16px;
        right: 10px;

        .v-chip {
          padding: 8px;
        }
      }
    }

    .c-details {
      background-color: #f3f3f3;
      margin-top: 50px;
      padding: 0px 12px;
      color: #3e515f;
      height: -webkit-fill-available;
      padding-bottom: 50px;

      .cd-title {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 18px;
      }

      .cd-subtitle {
        text-transform: uppercase;
        font-size: 13px;
      }

      .c-details-actions {
        width: 100%;
        margin-top: 17px;
        padding-bottom: 17px;
        overflow: hidden;

        .action {
          width: 32%;
          padding: 10px;
          border-radius: 10px;
          border: 1px solid #999;
          overflow: hidden;
          font-size: 13px;
          color: #3e515f;
          background-color: #fff;
          text-align: center;
          line-height: 9px;
          text-transform: uppercase;
          float: left;

          &:nth-child(2) {
            margin: 0 2%;
          }

          .a-icon {
            margin-bottom: 10px;
          }

          .a-title {
            font-size: 10px;
            font-weight: 700;
            margin-bottom: 7px;
          }

          .a-subtitle {
            font-size: 12px;
          }
        }
      }

      .c-details-item {
        width: 100%;
        padding: 10px 10px;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
        overflow: hidden;
        margin-top: 17px;
        font-size: 13px;
        color: #3e515f;
        background-color: #fff;

        .cdi-title {
          margin: 0px 5px 6px 3px;
          border-bottom: 1px solid #e8e9e9;
          font-size: 13px;
          padding-bottom: 5px;
          font-weight: 500;
          text-transform: uppercase;
        }

        .wc-table-payment {
          width: 100%;

          tr td {
            padding: 5px 12px;
            border: 1px solid #e8e9e9;
            border-radius: 5px;
            text-align: center;
          }
        }

        .wc-list {
          display: flex !important;
          overflow-x: auto;

          li {
            width: 180px !important;
          }
        }
      }

      .c-ads-banner {
        margin-top: 17px;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%);
      }
    }
  }
}

.dialog-vehicle {
  background-color: #f1f1f1;
  height: max-content;

  .header {
    background-color: #f1f1f1;
    position: fixed;
    width: 100%;
    z-index: 99;

    .vehicle-details {
      width: 100%;
      text-transform: uppercase;
      padding: 6px 5px;

      tr {
        text-align: center;

        td {
          border: 1px solid #d9d9d9;
          padding-top: 6px;
          border-radius: 4px;
          color: #3e515f;
          background-color: #fff;

          img {
            height: 30px;
          }

          .value {
            font-weight: bold;
            font-size: 15px;
            line-height: 15px;
          }

          .description {
            font-size: 10px;
          }
        }
      }
    }
  }

  .vehicle-name {
    width: 100%;
    background-color: #dbdbdb;
    color: #3e515f;
    font-size: 18px;
    font-weight: bold;
    padding: 5px 10px;
    text-transform: uppercase;

    .dialog-vehicle-close {
      border: 1px solid #3e515f;
      border-radius: 6px;
      margin: 0px !important;
      padding: 0px;
    }
  }

  .content {
    padding-bottom: 20%;
    padding-top: 107px;

    .no-results {
      padding: 20px;
      padding-top: 20%;
      text-align: center;
    }

    .service {
      margin-bottom: 10px;
      background-color: #fff;
      padding-top: 5px;
      overflow: hidden;

      .service-header {
        width: 100%;
        padding: 10px;
        overflow: hidden;

        .company-logo {
          float: left;
          width: 22%;
          text-align: center;
          border: 2px solid #f1f1f1;
          border-radius: 5px;
          padding: 4px 0px;
        }

        .details {
          float: left;
          width: 78%;
          line-height: 18px;
          padding: 0px 10px;

          .company-name {
            color: #3e515f;
            font-weight: bold;
            text-transform: uppercase;
            font-size: 15px;
            padding-bottom: 2px;
          }

          .company-type {
            font-size: 12px;
            color: #48b38b;
            text-transform: uppercase;
          }

          .service-date {
            font-size: 11px;
          }
        }
      }

      .serice-description {
        width: 100%;
        padding: 0px 10px;
        overflow: hidden;
      }

      .d-service-photos {
        padding: 10px;

        .v-carousel__controls {
          height: 35px !important;

          .v-btn--icon.v-size--small {
            height: 21px !important;
            width: 21px !important;
          }

          .v-icon {
            font-size: 13px !important;
          }
        }
      }

      .d-service-actions {
        margin: 0px 10px 10px 10px;
        font-size: 14px;
        border-top: 1px solid #eee;
        padding-top: 10px;

        table {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

.v-bottom-sheet.v-dialog {
  overflow-y: scroll;
}

.v-overlay__scrim {
  opacity: 0.56;
  background-color: #3e515f !important;
  border-color: #3e515f !important;
}

.welcome-message {
  .wl-h-title {
    font-size: 28px;
    color: #3f505f;
    font-weight: bold;
    padding-top: 18px;
    padding-left: 20px;
  }

  .wl-h-subtitle {
    color: #3f505f;
    padding: 0px 20px;
    font-size: 12px;
    padding-top: 2px;
  }

  .v-window {
    height: auto !important;
  }

  .v-window-item .v-image {
    height: auto !important;
  }

  .v-window__prev .v-btn,
  .v-window__next .v-btn {
    height: 30px !important;
    width: 30px !important;

    .v-icon {
      font-size: 20px !important;
    }
  }

  .wl-header {
    text-align: center;

    .v-image {
      margin: 0 !important;
    }
  }

  .wl-list {
    padding: 0 20px;
    padding-bottom: 10px;

    .v-alert {
      font-size: 13px !important;

      .v-icon {
        margin-left: 3px !important;
        font-size: 21px !important;
        height: 36px !important;
        min-width: 36px !important;
      }
    }
  }

  .final-step {
    margin: 20px;
    text-align: center;
    color: #3f505f;

    .v-alert {
      font-size: 13px !important;
    }
  }
}
</style>
